<template>
    <div>
        <div key="loading" class="flex col-span-12 justify-center" v-if="loading">
            <div class="aspect-[320/520] w-1/4 relative mb-sm sm:mb-md flex justify-center items-center">
                <i class="fa-regular fa-spinner-third h-[60px] w-auto animate-spin"></i>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-y-lg md:gap-y-xl xs:gap-x-md" v-else>
            <div class="hidden md:block md:col-span-1"></div>
            <div class="col-span-12 md:col-span-10 grid grid-cols-12 gap-y-lg md:gap-y-xl xs:gap-x-md">
                <div v-for="(item, index) in sortedArticles" :key="index" class="col-span-12 sm:col-span-6 md:col-span-4" :class="{ 'sm:last:hidden md:last:block': articles.length > 2 }">
                    <supportitem :content="item" :distance-object="getDistanceForId(item.id)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import supportitem from './item';

export default {
    name: 'supporthighlight',
    props: ['exclude'],

    data() {
        return {
            params: {
                per_page: 99,
                page: 1,
                exclude: [],
            },
            loading: false,
            articles: [],
            distances: null,
            distanceLookup: {},
            lat: null,
            lng: null,
        };
    },

    mounted() {
        this.params.exclude = [this.exclude.id];
        this.lat = this.exclude.acf.address_google_maps.lat;
        this.lng = this.exclude.acf.address_google_maps.lng;
        this.getArticles();
    },

    methods: {
        getArticles() {
            this.loading = true;

            axios
                .get('/api/support-articles', { params: { ...this.params } })
                .then((response) => {
                    if (response.data.status === 200) {
                        this.articles = response.data.data;

                        this.calculateAllDistances();
                    } else {
                        this.articles = [];
                    }
                })
                .finally(() => (this.loading = false));
        },

        calculateAllDistances() {
            const self = this;
            let distances = [];
            let distanceLookup = {};

            self.articles.forEach((o) => {
                let shortestLocation = o.acf.address_google_maps;
                let shortestDistance = self.calculateDistance(self.lat, self.lng, o.acf.address_google_maps.lat, o.acf.address_google_maps.lng, 'K');
                if (o.acf.other_addresses) {
                    o.acf.other_addresses.forEach((other) => {
                        let otherDistance = self.calculateDistance(self.lat, self.lng, other.address_google_maps.lat, other.address_google_maps.lng, 'K');
                        if (otherDistance < shortestDistance) {
                            shortestDistance = otherDistance;
                            shortestLocation = other.address_google_maps;
                        }
                    });
                }

                let distanceObject = {
                    id: o.id,
                    location: shortestLocation,
                    distance: Math.round(shortestDistance),
                };
                distances.push(distanceObject);
                distanceLookup[o.id] = distanceObject.distance;
            });

            function compare(a, b) {
                if (a.distance < b.distance) {
                    return -1;
                }
                if (a.distance > b.distance) {
                    return 1;
                }
                return 0;
            }

            distances.sort(compare);
            self.distances = distances;
            self.distanceLookup = distanceLookup;
        },

        calculateDistance(lat1, lon1, lat2, lon2, unit) {
            if (lat1 == lat2 && lon1 == lon2) {
                return 0;
            } else {
                var radlat1 = (Math.PI * lat1) / 180;
                var radlat2 = (Math.PI * lat2) / 180;
                var theta = lon1 - lon2;
                var radtheta = (Math.PI * theta) / 180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = (dist * 180) / Math.PI;
                dist = dist * 60 * 1.1515;
                if (unit == 'K') {
                    dist = dist * 1.609344;
                }
                if (unit == 'N') {
                    dist = dist * 0.8684;
                }
                return dist;
            }
        },

        getDistanceForId(id) {
            if (this.distances && this.distances.length) {
                const distanceobjects = this.distances.filter((d) => {
                    return id === d.id;
                });

                if (distanceobjects.length) {
                    return distanceobjects[0];
                }
            }
            return false;
        },
    },

    computed: {
        sortedArticles() {
            if (this.distances != null && this.distances.length === this.articles.length) {
                let sortedArticles = [];

                this.distances.forEach((d) => {
                    let article = null;
                    let filteredArticles = this.articles.filter((o) => {
                        return o.id === d.id;
                    });

                    if (filteredArticles.length > 0) {
                        article = filteredArticles[0];
                    }

                    sortedArticles.push(article);
                });

                return sortedArticles.slice(0, 3);
            }
            return this.articles;
        },
    },

    components: {
        supportitem,
    },
};
</script>
